<div class="flex items-center justify-between">
  <div class="typo-h2 font-semibold">
    {{ (isPatientContext ? 'collab_sidebar_clinical_collabs_title' : 'collab_sidebar_all_collabs_title') | translate }}
  </div>

  <button
    class="btn-primary h-10"
    (click)="onCreateNewCollab()"
    [ngClass]="{
      'animate-pulse bg-background-light-grey text-text-light shadow-background-light-grey': patientDataState === DataState.Loading
    }"
    [disabled]="patientDataState === DataState.Loading"
  >
    {{ 'collab_sidebar_new_collab' | translate }}
  </button>
</div>

@if ((collabList.state === DataState.Fetched && collabList.data) || areFiltersEnabled() || collabList.state === DataState.Loading) {
  <form class="flex flex-col gap-y-5" [formGroup]="formGroup">
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <lib-input class="flex-1" [formControl]="searchTermControl" [placeholder]="'collab_sidebar_search' | translate">
          <svg-icon key="px-24-search" class="text-text-tertiary" leftIcon></svg-icon>
          @if (searchTermSignal() && searchTermSignal()!.length > 0) {
            <button
              class="inline-grid place-items-center rounded-full bg-background-disabled p-1"
              rightIcon
              type="button"
              (click)="clearSearchInput()"
            >
              <svg-icon class="text-text-light" key="px-16-x" size="sm"></svg-icon>
            </button>
          }
        </lib-input>
        @if (showSiteFilter) {
          <button
            class="inline-grid place-items-center p-2 text-primary-blue transition-colors"
            type="button"
            (click)="toggleFilters.emit()"
          >
            <svg-icon class="transition-colors" key="px-24-filter"></svg-icon>
          </button>
        }
      </div>

      <div
        class="grid-rows-[1fr] transition-all"
        [ngClass]="{
          hidden: !filtersOpen,
          grid: filtersOpen
        }"
      >
        <div class="flex flex-col gap-4 overflow-hidden">
          <div class="flex justify-between gap-2">
            @if (showSiteFilter) {
              <lib-dropdown
                class="w-full"
                formControlName="selectedSiteIds"
                [options]="sites"
                [multi]="true"
                [checkbox]="true"
                i18nAllSelected="collab_sidebar_all_practices_selected"
                i18nMultipleSelected="collab_sidebar_multiple_practices_selected"
              ></lib-dropdown>
              <button type="button" (click)="onClearFilters()" class="typo-h4-semibold text-primary-blue">
                {{ 'collab_sidebar_clear' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="mb-[-12px] flex gap-1 overflow-x-scroll pb-3">
      <button
        type="button"
        class="flex shrink-0 items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
        [ngClass]="{
          'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': this.formGroup.controls.directOnly.value,
          'border-primary-blue bg-background-white': !this.formGroup.controls.directOnly.value,
          'shrink-0': hasDeletedCollabs()
        }"
        (click)="onDirectToMeClick()"
      >
        <span class="typo-h7-semibold whitespace-nowrap">{{ 'collab_sidebar_direct_to_me_button' | translate }}</span>
      </button>
      <button
        type="button"
        class="flex shrink-0 items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
        [ngClass]="{
          'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': formGroup.controls.unreadOnly.value,
          'border-primary-blue bg-background-white': !formGroup.controls.unreadOnly.value,
          'shrink-0': hasDeletedCollabs()
        }"
        (click)="onUnreadClick()"
      >
        <span class="typo-h7-semibold whitespace-nowrap">{{ 'collab_sidebar_unread_button' | translate }}</span>
      </button>
      @if (!isPatientContext) {
        <button
          type="button"
          class="flex shrink-0 items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
          [ngClass]="{
            'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': formGroup.controls.teamCollab.value,
            'border-primary-blue bg-background-white': !formGroup.controls.teamCollab.value,
            'shrink-0': hasDeletedCollabs()
          }"
          (click)="onTeamCollabClick()"
        >
          <span class="typo-h7-semibold whitespace-nowrap">{{ 'collab_type_team_collab' | translate }}</span>
        </button>
        <button
          type="button"
          class="flex shrink-0 items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
          [ngClass]="{
            'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': formGroup.controls.clinicalCollab.value,
            'border-primary-blue bg-background-white': !formGroup.controls.clinicalCollab.value,
            'shrink-0': hasDeletedCollabs()
          }"
          (click)="onClinicalCollabClick()"
        >
          <span class="typo-h7-semibold whitespace-nowrap">{{ 'collab_type_clinical_collab' | translate }}</span>
        </button>
      }
      @if (hasDeletedCollabs()) {
        <button
          type="button"
          class="flex shrink-0 items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
          [ngClass]="{
            'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': this.formGroup.controls.recentlyDeleted.value,
            'border-primary-blue bg-background-white': !this.formGroup.controls.recentlyDeleted.value
          }"
          (click)="onRecentlyDeletedClick()"
        >
          <span class="typo-h7-semibold whitespace-nowrap">{{ 'collab_sidebar_recently_deleted_button' | translate }}</span>
        </button>
      }
    </div>
    @if (this.formGroup.controls.recentlyDeleted.value) {
      <div class="typo-h5-book w-full leading-none text-text-secondary">
        {{ 'collab_delete_info' | translate }}
      </div>
    }
    @if (!areFiltersEnabled()) {
      <div class="typo-h7-light w-full text-end text-text-light">
        {{ 'home_right_side_bar_message_count' | translate: { input1: collabList.data?.length } }}
      </div>
    }
  </form>
}
<div libInfiniteScrollList class="flex flex-grow flex-col gap-3 overflow-auto" (endReached)="onCollabListEndReached()">
  @if (collabList.data && collabList.data.length > 0) {
    <!-- Collaborations -->
    @for (collab of collabList.data; track collab.id; let isLast = $last) {
      <lib-collaboration-list-item
        libInfiniteScrollListItem
        [participants]="collab.avatars ?? []"
        [subject]="collab.title"
        [participantsString]="undefined | collaborationDynamicTitle: collab.participants : currentUserIds"
        [hasUnreadMessage]="collab.hasUnreadMessage"
        [hasAttachmentInLastMessage]="collab.hasAttachmentInLastMessage"
        [dateOfLastMessage]="collab.dateOfLastMessage"
        [lastMessage]="collab.lastMessage"
        [lastMessageSenderFirstName]="collab.lastMessageSenderFirstName"
        [linkedPatient]="collab.linkedPatient"
        [isSelected]="collab.id === selectedCollab.data?.id"
        [searchTextToHighlight]="searchTermSignal()"
        [daysLeftOfDeletion]="collab.daysLeftOfDeletion"
        [isCreatedBySelf]="collab.isCreatedBySelf"
        [isSupportCollab]="collab.isSupportCollab"
        [isUserSiteAdmin]="collab.isUserSiteAdmin"
        (click)="onListItemClick(collab.id)"
        (leaveCollaboration)="onLeaveCollaborationClick(collab.id)"
        (recoverCollaboration)="onRecoverCollaborationClick(collab.id)"
        (deleteCollaboration)="onDeleteCollaborationClick(collab.id, $event)"
      ></lib-collaboration-list-item>
      @if (!isLast) {
        <hr class="mx-3 text-background-disabled" />
      }
    }
  }

  @if (collabList.state === DataState.Fetched && collabList.data && collabList.data.length === 0) {
    <div class="mb-12 flex flex-1 flex-col items-center justify-center gap-3 self-center">
      <div class="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-background-disabled/50 p-3">
        <svg-icon class="relative z-10 text-text-light" key="px-24-collab" size="md"></svg-icon>
      </div>

      <span class="typo-h5-light text-center font-light text-text-light">
        {{ (areFiltersEnabled() ? 'collab_sidebar_filter_no_colllabs' : 'collab_sidebar_no_collabs') | translate }}
      </span>
    </div>
  }

  @if (collabList.state === DataState.Loading) {
    @for (item of loadingSkeletons(); track $index) {
      <div class="mb-4 h-20 animate-pulse rounded-3xl bg-background-light-grey">
        <div class="flex items-center gap-4 p-4">
          <div class="flex flex-1 flex-col">
            <div class="h-4 w-36 rounded-lg bg-background-disabled"></div>
            <div class="mt-1 h-3 w-24 rounded-lg bg-background-disabled"></div>
          </div>
          <div class="h-12 w-12 rounded-full bg-background-disabled"></div>
        </div>
      </div>
    }
  }
</div>

<div
  class="absolute inset-0 transition-colors"
  [ngClass]="{
    'pointer-events-auto bg-background-white/80': isDisabled,
    'pointer-events-none': !isDisabled
  }"
></div>
